<template>
    <el-button :icon="params.props.icon" :size="size" :style="params.props.style" @click="click">{{params.props.text}}</el-button>
</template>

<script>
export default {
  props: {
    size: {
      default: 'mini'
    }
  },
  methods: {
    click () {
      this.params.props.action(this.params.data, this.params.props, this.params.rowIndex)
    }
  }
}
</script>
